const toTitleCase = (value) => value
  .replace(/_/g, ' ')
  .replace(/\b\w/g, (char) => char.toUpperCase());

const flattenApiMessages = (value, prefix = '') => {
  if (value == null) {
    return [];
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return [prefix ? `${prefix}: ${String(value)}` : String(value)];
  }

  if (Array.isArray(value)) {
    return value.flatMap((item) => flattenApiMessages(item, prefix));
  }

  if (typeof value === 'object') {
    return Object.entries(value).flatMap(([key, nestedValue]) => {
      const nextPrefix = ['detail', 'message', 'error', 'errors', 'non_field_errors'].includes(key)
        ? prefix
        : toTitleCase(key);
      return flattenApiMessages(nestedValue, nextPrefix);
    });
  }

  return [prefix ? `${prefix}: ${String(value)}` : String(value)];
};

export const getApiErrorMessage = (error, fallbackMessage = 'Something went wrong. Please try again.') => {
  const responseData = error?.response?.data;
  const messages = flattenApiMessages(responseData).filter(Boolean);

  if (messages.length > 0) {
    return [...new Set(messages)].join('\n');
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage;
};